<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
import globalData from './globalData.js'
import { initWxConfig, initAgentConfig, buildAuthorization } from '@/common/utils/enterprise_weixin'
export default {
  globalData,
  async onLaunch(options) {
    let userId = uni.getStorageSync('userId')
    if (options.query.code) {
      getApp().globalData.$loading({ message: '授权中...' });
      const data = await getApp().globalData.$universalAsk.get(`/enterprise/cgi-bin/service/auth/getuserinfo3rd`, {
        suiteid: getApp().globalData.$suiteId,
        code: options.query.code,
        state: options.query.state
      })
      if (data._status === 200) {
        uni.setStorageSync('userId', data.userid);
        uni.setStorageSync('open_userid', data.open_userid);
        uni.setStorageSync('corpId', data.corpid);
        uni.setStorageSync('name', data.name);
        uni.setStorageSync('avatar', data.avatar);
        uni.setStorageSync('qr_code', data.qr_code);
        await initWxConfig()
        setTimeout(async function(){
          await initAgentConfig()
        }, 300)
      }
      getApp().globalData.$hideloading()
    } else {
      if (!userId) {
        await buildAuthorization()
      } else {
        await initWxConfig()
        setTimeout(async function(){
          await initAgentConfig()
        }, 300)
      }
      getApp().globalData.$hideloading()
    }
  },
  async onShow() {
  },
  methods: {
  },
}
</script>

<style lang="scss">
@import './common/styles/app.scss';
</style>